import React from 'react';
import { useTranslation } from 'react-i18next';

import { SONAR_SECTIONS, VIEWS } from '../../constants';
import BottomCharts from '../bottom-charts/BottomCharts';
import { SONAR_DATA_KEYS, getSortingByStat } from '../../utils/chart';
import { getTopAndVisibleDomains, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';

const CHART_INDEX = 1;

function RivalryAll() {
  const { t } = useTranslation('sonar');

  const viewOptions = [
    { label: 'Top 10', value: VIEWS.TOP_10 },
    { label: 'Top 20', value: VIEWS.TOP_20 },
    { label: t('focus'), value: VIEWS.FOCUS },
    { label: t('all'), value: VIEWS.ALL },
    { label: t('groups'), value: VIEWS.GROUPS },
  ];

  return (
    <BottomCharts
      section={SONAR_SECTIONS.FRICTION}
      chartIndex={CHART_INDEX}
      viewOptions={viewOptions}
      getEntriesSelector={getEntriesSelector}
      dataKey={SONAR_DATA_KEYS.FRICTION}
      scatterDataKeys={[SONAR_DATA_KEYS.FRICTION]}
      isTrendReversed
    />
  );
}

const ADDITIONAL_VIEW_SELECTORS = {
  [VIEWS.TOP_10]: getTopAndVisibleDomains(10, getSortingByStat(SONAR_DATA_KEYS.FRICTION)),
  [VIEWS.TOP_20]: getTopAndVisibleDomains(20, getSortingByStat(SONAR_DATA_KEYS.FRICTION)),
};

function getEntriesSelector(view, group) {
  return ADDITIONAL_VIEW_SELECTORS[view] || getVisibleEntriesForView(view, group);
}

export default RivalryAll;
